
import { IOption, todoTypeTool as _todoTypeTool } from '@/views/config/todoType/todoType';

type ITodoInfo = ITodo.IResponse.ITodoInfo;
type ITodoTemplateInfo = IModule.IResponse.ITodoTemplateInfo;
type IOptionInfo = ITodo.IOptionInfo;

export type ITodoTypeOptions = IOption;

export const statusList: ITodo.ITodoStatus[] = ['Processing', 'Completed', 'Closed', 'Reviewed'];

export const generateStatusFilters = (): Array<{text: string, value: string}> => {
  return statusList.map((status) => ({
    text: status,
    value: status,
  }));
};

export const todoTypeTool = _todoTypeTool;


type Key = 'typeId' | 'typeName' | 'owner' | 'ownerName' | 'status' | 'projectId' | 'projectName' | 'settlementConfigurationName' | 'settlementConfigurationId';
const generateOptionsByKey = <T>(dataSource: T[], valueKey: keyof T, textKey: keyof T): IOptionInfo[] => {
  const result: IOptionInfo[] = [];
  const values: string[] = [];
  for (const item of dataSource) {
    const filterKey =  String(item[valueKey]);
    if (!values.includes(filterKey)) {
      const text = item[textKey] || item[valueKey];
      const value = String(item[valueKey]);
      result.push({
        text: String(text),
        value: (item[valueKey] as unknown) as string,
      });
      values.push(value);
    }
  }
  return result;
};

const generateOwnerOptions = (todoList: ITodoInfo[]): IOptionInfo[] => {
  const result: IOptionInfo[] = [];
  const values: Array<string | null> = [];
  for (const item of todoList) {
    if (!values.includes(item.owner)) {
      const text = item.ownerName || 'null';
      const value = item.owner;
      result.push({
        text,
        value: item.owner || 'Null',
      });
      values.push(value);
    }
  }
  return result;
};
export const generateOptions = (todoList: ITodoInfo[]): ITodo.ITodoTableFilterOption => {
  return {
    typeOption: generateOptionsByKey(todoList, 'typeId', 'typeName'),
    ownerOption: generateOwnerOptions(todoList),
    statusOption: generateOptionsByKey(todoList, 'status', 'status'),
    projectOption: generateOptionsByKey(todoList, 'projectId', 'projectName'),
    settlementUnitOption: generateOptionsByKey(todoList, 'settlementConfigurationId', 'settlementConfigurationName'),
  };
};
export const generateTemplateOptions = (todoList: ITodoTemplateInfo[]) => {
  return {
    typeOption: generateOptionsByKey(todoList, 'typeId', 'typeName'),
    statusOption: generateOptionsByKey(todoList, 'todoStatus', 'todoStatus'),
    settlementUnitOption: generateOptionsByKey(todoList, 'settlementConfigurationId', 'settlementConfigurationName'),
  };
};

export const addOptions = (sourceOption: IOptionInfo[], newOption: IOptionInfo[]): IOptionInfo[] => {
  const values = sourceOption.map((opt) => opt.value);
  const filteredOption = newOption.filter((item) => !values.includes(item.value));
  return [...sourceOption, ...filteredOption];
};
